import styled from 'styled-components'

export const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1em 2.5em;
`

export const styles = {
  avatar: {
    width: 100,
    height: 100
  }
}



// WEBPACK FOOTER //
// ./src/components/Sidebar/styles.js